export default "/assets/site/images/Rectangle 17.png?263617a635c5fed1a1e21910f47d8e40";